import {
  AcceptOrderFoodOrderPayload,
  CreateOrderPayload,
  CreatePostPaidOrderPayload,
  CreateQuickOrderPayload,
  EditPostPaidOrderPayload,
  GetMyOrdersParams,
  GetOrdersParams,
  NeedForCallOrderPayload,
  NotificationOrderReadyCommand,
  PickOrderPayload,
  PrintOrderPayload,
  RefundOrderPayload,
} from '../../models/payload/order';
import { BankPaymentServiceType } from '../../models/response/banks';
import { OrderChangeStatus } from '../../models/response/order';
import { offlineRopoloRequest, ropoloRequest } from '../axios';

const getOrders = async (params: GetOrdersParams) =>
  (
    await ropoloRequest.ordersList(params, {
      paramsSerializer: {
        indexes: null,
      },
    })
  ).data;

const getOrder = async ({ id, networkStatus }: { id: string; networkStatus: boolean }) =>
  (await (networkStatus ? ropoloRequest.ordersDetail(id) : offlineRopoloRequest.ordersDetail(id))).data;

const getOrderTransactions = async (id: string) => (await ropoloRequest.ordersTransactionsDetail(id)).data.data;

const getMyOrder = async (params: GetMyOrdersParams) => (await ropoloRequest.ordersMeList(params)).data;

const createOrder = async (payload: CreateOrderPayload) => (await ropoloRequest.ordersCreate(payload)).data;

const createQuickOrder = async (payload: CreateQuickOrderPayload) =>
  (await ropoloRequest.ordersQuickCreate(payload)).data;

const createOfflineOrder = async ({ payload }: { payload: CreatePostPaidOrderPayload }) =>
  (await ropoloRequest.ordersPostpaidCreate(payload)).data;

const getPaymentUrl = async (
  id: string,
  submitUrl: string,
  paymentServiceType?: BankPaymentServiceType,
  tip?: number
) => (await ropoloRequest.ordersPaymentDetail(id, { submitUrl, paymentServiceType, tip })).data;

const changeState = async (params: OrderChangeStatus, networkStatus: boolean) =>
  (await (networkStatus ? ropoloRequest.ordersPartialUpdate(params) : offlineRopoloRequest.ordersPartialUpdate(params)))
    .data;

const refundOrderItems = async ({ command }: { command: RefundOrderPayload; networkStatus?: boolean }) =>
  (await ropoloRequest.ordersRefundUpdate(command)).data;

const getRejectedReasons = async () => (await ropoloRequest.snappfoodOrdersRejectcausesList()).data;

const getOrderDiscountDescription = async (billNumber: string) =>
  (await ropoloRequest.snappfoodOrdersCouponsDetail(billNumber)).data;

const setPickToFoodOrder = async (command: PickOrderPayload) =>
  (await ropoloRequest.snappfoodOrdersPickCreate(command)).data;

const acceptFoodOrderService = async (command: AcceptOrderFoodOrderPayload) =>
  (await ropoloRequest.snappfoodOrdersAcceptCreate(command)).data;

const ackFoodOrderService = async (command: AcceptOrderFoodOrderPayload) =>
  (await ropoloRequest.snappfoodOrdersAckCreate(command)).data;

const needCallService = async (command: NeedForCallOrderPayload) =>
  (await ropoloRequest.snappfoodOrdersRejectCreate(command)).data;

const updatePostPay = async ({
  command,
  networkStatus,
}: {
  command: EditPostPaidOrderPayload;
  networkStatus: boolean;
}) =>
  (
    await (networkStatus
      ? ropoloRequest.ordersEditpostpaidUpdate(command)
      : offlineRopoloRequest.ordersEditpostpaidUpdate(command))
  ).data;

const orderRefoundReport = async (orderId: string) =>
  (await ropoloRequest.reportsRefundorderreportDetail(orderId)).data;

const callForReadyOrder = async (orderId: string) => (await ropoloRequest.ordersCallforreadyorderUpdate(orderId)).data;
const sendMessageForReadyOrder = async (command: NotificationOrderReadyCommand) =>
  (await ropoloRequest.ordersNotificationReadyCreate(command)).data;

const changeTransactionStatus = (orderId: string[]) =>
  ropoloRequest.transactionsTransactionStatusPartialUpdate({ orderId });

const printOrder = async (command: PrintOrderPayload) => (await ropoloRequest.ordersPrintorderCreate(command)).data;

export {
  acceptFoodOrderService,
  ackFoodOrderService,
  callForReadyOrder,
  changeState,
  createOfflineOrder,
  createOrder,
  createQuickOrder,
  getMyOrder,
  getOrder,
  getOrderDiscountDescription,
  getOrders,
  getOrderTransactions,
  getPaymentUrl,
  getRejectedReasons,
  needCallService,
  orderRefoundReport,
  refundOrderItems,
  setPickToFoodOrder,
  updatePostPay,
  changeTransactionStatus,
  sendMessageForReadyOrder,
  printOrder,
};
